import { render } from "./PostTransplantSectionDetailsEMROATS.vue?vue&type=template&id=ae2ef00a&scoped=true"
import script from "./PostTransplantSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./PostTransplantSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./PostTransplantSectionDetailsEMROATS.vue?vue&type=style&index=0&id=ae2ef00a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae2ef00a"],['__file',"src/components/PostTransplantSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae2ef00a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae2ef00a', __exports__)) {
    api.reload('ae2ef00a', __exports__)
  }
  
  module.hot.accept("./PostTransplantSectionDetailsEMROATS.vue?vue&type=template&id=ae2ef00a&scoped=true", () => {
    api.rerender('ae2ef00a', render)
  })

}


export default __exports__